module.exports = __webpack_public_path__ + "img/calendar-disabled.6346a147.svg";